var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.333 9.063-.943-.944-6.23 6.231-6.23-6.23-.943.943 7.174 7.172z",
    fillRule: "evenodd"
  })));
};
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xOS4zMzMgOS4wNjMtLjk0My0uOTQ0LTYuMjMgNi4yMzEtNi4yMy02LjIzLS45NDMuOTQzIDcuMTc0IDcuMTcyeiIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";